import i18next from 'i18next';
import { trackPromise } from 'react-promise-tracker';
import api from '../api/api';
import pdfApi from '../api/pdfApi';
import ComprasMockService from './mocks/ComprasMockService';
import { MocksHelper } from './mocks/MocksHelper';

// eslint-disable-next-line react-hooks/rules-of-hooks
const mocked = MocksHelper.useMocks();

const CompraService = {
  retrieveCompra: (data: object) =>
    trackPromise(
      api.post(
        `/rest/compras/tickets/${i18next.language}/get/page/info`,
        JSON.stringify(data),
      ),
    ),
  retrieveCompraByDates: (data: object) => {
    return trackPromise(
      api.post(
        `/rest/compras/tickets/${i18next.language}/get/page/filtred/info`,
        JSON.stringify(data),
      ),
    );
  },
  detalleCompraDownload: (params: number) => {
    return trackPromise(
      pdfApi.get(
        `/rest/compras/tickets/${i18next.language}/download/detalle/compra/id?idCompra=${params}`,
      ),
    );
  },
  ticketDownload: (params: number) =>
    trackPromise(
      pdfApi.get(
        `/rest/compras/tickets/${i18next.language}/download/ticket/id?idTicket=${params}`,
      ),
    ),
  ticketOption: (data: object) =>
    trackPromise(
      api.put(
        `/rest/compras/tickets/update/tickets/papel/option`,
        JSON.stringify(data),
      ),
    ),
  ticketPapelState: () =>
    trackPromise(api.post(`/rest/compras/tickets/get/estado/servicio`)),
};
export default mocked ? ComprasMockService : CompraService;
